import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBoxOpen, faPrint, faChartPie } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home-section-pc',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './home-section-pc.component.html',
  styleUrls: ['./home-section-pc.component.scss'],
})
export class HomeSectionPcComponent {
  public titleKey = 'home.pc.title';
  public subtitleKey = 'home.pc.subtitle';
  public items = [
    {
      icon: faBoxOpen,
      titleKey: 'home.pc.items.createOrders.title',
      textKey: 'home.pc.items.createOrders.text',
    },
    {
      icon: faPrint,
      titleKey: 'home.pc.items.printLabels.title',
      textKey: 'home.pc.items.printLabels.text',
    },
    {
      icon: faChartPie,
      titleKey: 'home.pc.items.instantReports.title',
      textKey: 'home.pc.items.instantReports.text',
    },
  ];
}
